
import { PlanScope, PermissionKey, GrantType } from '@/common/permission';
import AuthorizePlanRange from './components/authorize-plan-range.vue';
import AuthorizePlanAuthority from './components/authorize-plan-authority.vue';
import AuthorizePlanPlayable from './components/authorize-plan-playable.vue';

export default {
  components: {
    AuthorizePlanRange: AuthorizePlanRange,
    AuthorizePlanAuthority: AuthorizePlanAuthority,
    AuthorizePlanPlayable: AuthorizePlanPlayable
  },
  props: {
    authorizeInfo: {
      type: Object,
      default: function _default() {
        return {};
      }
    },

    formValue: {
      type: Object,
      required: true
    },

    action: {
      type: String,
      default: 'create'
    }
  },
  data: function data() {
    return {};
  },

  computed: {
    showPlayableAttrs: function showPlayableAttrs() {
      return this.formValue.plan_scope === PlanScope.Playable || this.formValue.plan_scope === PlanScope.Playable_Video;
    },
    showVideoAttrs: function showVideoAttrs() {
      return this.formValue.checkPermissions.includes(PermissionKey.ve + ',' + PermissionKey.veBatch);
    },
    showAiAttrs: function showAiAttrs() {
      return this.formValue.checkPermissions.includes(PermissionKey.aigc);
    }
  },
  methods: {
    checkDisabled: function checkDisabled() {
      return this.action === 'update' || this.formValue.grant_type !== GrantType.Normal;
    }
  }
};